import React from "react";
import { Link } from "react-router-dom";
import { Star, Clock, MessageCircle, Heart } from "lucide-react";
import { waLink } from "../lib/api";
import { useWishlist } from "./WishlistContext";

export default function PackageCard({ p, index = 0 }) {
  const { toggle, has } = useWishlist();
  const inWl = has(p.id);
  return (
    <article className="group card-glass hover:-translate-y-1 hover:shadow-2xl transition-all duration-500" data-testid={`package-card-${p.slug}`}>
      <Link to={`/packages/${p.slug}`} className="block relative overflow-hidden">
        <div className="aspect-[4/3] overflow-hidden bg-slate-100">
          <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
        </div>
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="text-[10px] tracking-wider uppercase font-semibold bg-[#FF7D00] text-white px-3 py-1 rounded-full">{p.destination}</span>
          {p.featured && <span className="text-[10px] tracking-wider uppercase font-semibold bg-white text-[#0A2540] px-3 py-1 rounded-full">Featured</span>}
        </div>
        <button onClick={(e) => { e.preventDefault(); toggle(p.id); }} className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/90 backdrop-blur flex items-center justify-center hover:bg-white" data-testid={`wishlist-${p.slug}`} aria-label="Wishlist">
          <Heart className={`w-4 h-4 ${inWl ? "fill-[#FF7D00] text-[#FF7D00]" : "text-[#0A2540]"}`} />
        </button>
      </Link>
      <div className="p-5">
        <div className="flex items-center justify-between text-xs muted mb-2">
          <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {p.duration}</span>
          <span className="flex items-center gap-1"><Star className="w-3.5 h-3.5 fill-[#FF7D00] text-[#FF7D00]" /> {p.rating} ({p.reviews})</span>
        </div>
        <Link to={`/packages/${p.slug}`}><h3 className="font-display font-semibold text-lg text-[#0A2540] mb-2 line-clamp-1 hover:text-[#006CE4]">{p.title}</h3></Link>
        <p className="text-sm muted line-clamp-2 mb-4">{(p.inclusions || []).slice(0, 3).join(" · ")}</p>
        <div className="flex items-end justify-between">
          <div>
            <div className="text-[11px] muted">Starting from</div>
            <div className="font-display font-bold text-2xl text-[#0A2540]">₹{p.price.toLocaleString("en-IN")}<span className="text-xs muted font-normal"> /person</span></div>
          </div>
          <div className="flex gap-2">
            <a href={waLink(`Hi, I'm interested in the ${p.title} package. Please share details.`)} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#25D366] text-white flex items-center justify-center hover:scale-105 transition" data-testid={`wa-${p.slug}`} aria-label="WhatsApp"><MessageCircle className="w-4 h-4" /></a>
            <Link to={`/packages/${p.slug}`} className="text-sm font-medium bg-[#0A2540] text-white px-4 py-2 rounded-full hover:bg-[#006CE4] transition" data-testid={`view-${p.slug}`}>View</Link>
          </div>
        </div>
      </div>
    </article>
  );
}
